/* global BX, arNextOptions */
import {refreshBasketFly} from './refresh-basket-fly';

(function () {
    async function delayProduct(event) {
        const button = event.target.closest('.wish_item');
        if (!button) return;

        event.preventDefault();

        const itemBlock = button.closest('.basket-fly__item');
        if (!itemBlock) return;

        const productId = itemBlock.getAttribute('product-id');

        if (!productId) return;

        try {
            button.classList.add('is-loading');

            const quantityInput = itemBlock.querySelector('#QUANTITY_' + itemBlock.getAttribute('data-id'));

            const quantity = quantityInput ? quantityInput.value : 1;

            await fetch(`${arNextOptions.SITE_DIR}ajax/item.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                },
                body: new URLSearchParams({
                    wish_item: 'Y',
                    item: productId,
                    quantity: quantity,
                }),
            });

            await refreshBasketFly();

            if (typeof window.delFromBasketCounter === 'function') {
                window.delFromBasketCounter(productId);
            }

            if (typeof BX !== 'undefined') {
                BX.onCustomEvent('onCompleteAction', [{action: 'loadBasket'}]);
            }
        } catch (e) {
            console.error('delayProduct error:', e);
        } finally {
            button.classList.remove('is-loading');
        }
    }

    function init() {
        document.addEventListener('click', delayProduct);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
